import React from "react";
import "./TestResultCard.scss";
import { Card, Divider } from "@material-ui/core";
import translate from "../../../i18n/translate";
import moment from "moment";
import TestResultScoreBar from "../TestResultScoreBar/TestResultScoreBar";
import { getRandomNumber } from "../utils/sharedUtils";

const TestResultCard = (props: any) => { 

  const formatDate = (dateString: string) => {
    return dateString ? moment(dateString).format('MMM DD, YYYY') : '----';
  }

  const percentageCalculator = (obtained_score: any, total_score: any) => {
    return Math.round((parseInt(obtained_score)/parseInt(total_score))*100) ? Math.round((parseInt(obtained_score)/parseInt(total_score))*100) : 0 
  }

  return (
    <Card className="testcard">
      <div className="testcard-heading">
        <div className="testcard-heading-title">
          <div className="testcard-heading-title-main" title={props?.result?.test_name}>{props?.result?.test_name}</div>
          <div className="testcard-heading-title-sub">{props.result.product_name}</div>
        </div>
        <div className="testcard-heading-date">
          <div className="testcard-heading-date-main">{translate("progress_testresults_table_date")}:</div>
          <div className="testcard-heading-date-sub">{formatDate(props.result.completed_date || "")}</div>
        </div>
      </div>
      <TestResultScoreBar
          progressPercentage = {percentageCalculator(props.result.score, props.result.total_score)}
          sectionName = {translate("progress_totalscore")}
          isTotalScore = {true}
        />
      <Divider className="testcard-divider" />
      {props.result.test_section_scores.map((scores: any, index: any) => {
          return <TestResultScoreBar
                    key={getRandomNumber(index)}
                    progressPercentage = {percentageCalculator(scores.score, scores.total_score)}
                    sectionName = {`${scores.section}:`}
                  />
                               
      })}
      <Divider className="testcard-divider" />
      <div className="testcard-level">
        <div className="testcard-level-text">
          <div className="testcard-level-text-main">{translate("progress_testresults_placed_text")} : &nbsp;</div>
          <div className="testcard-level-text-sub">{props.result.test_level}</div>
        </div>
      </div>
    </Card>
  );
};

export default TestResultCard;
